<template>
  <p-input-switch
    :disabled="props.disabled"
    class="notifi-input-switch"
    :model-value="props.checked"
    @update:model-value="props.setChecked"
  />
</template>

<script lang="ts" setup>
type NotifiToggleProps = {
  checked: boolean;
  setChecked?: (checked: boolean) => void;
  disabled: boolean;
};

const props = defineProps<NotifiToggleProps>();
</script>

<style scoped lang="scss">
.notifiEventTypeRowContainer {
  &:not(.p-inputswitch-checked) .p-inputswitch-slider {
    background: #5a5a83;
  }

  .p-inputswitch-checked > .p-inputswitch-slider {
    background-color: #c4b5fd;
    &:hover {
      background-color: #472393;
    }
  }

  .notifi-input-switch:disabled {
    cursor: default;
  }

  .p-disabled,
  .p-component:disabled {
    opacity: 1;
  }
}
</style>
